export const TRANSACTION_ADDRESS = {
  BUFFER: 'buffer',
  CARD_ORDER_FEE: 'card order fee',
  EXCHANGE: 'exchange',
  PGW: 'payment gateway',
  SYSTEM_LOAD: 'system load',
  LOAN_PAYOUT: 'loan payout',
};

export const TRANSACTIONS_STATE = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  DECLINED: 'declined',
  REFUNDED: 'refunded',
};

export const TRANSACTION_TYPE = {
  FEE: 'fee',
  EXCHANGE: 'exchange',
  SEND: 'send',
  RECEIVE: 'receive',
  REFUND: 'refund',
  LOAN_REPAYMENT: 'loan_repayment',
  LOAN_MONTHLY_INTEREST: 'loan_monthly_interest',
  LOAN_LOCK_COLLATERAL: 'loan_lock_collateral',
  LOAN_RELEASE_COLLATERAL: 'loan_release_collateral',
  LOAN_LOAD: 'loan_load',
  LOAN_COLLATERAL_PAYMENT: 'loan_collateral_payment',
  LOAN_COLLATERAL_LIQUIDATION: 'loan_collateral_liquidation',
  BANK_WITHDRAWAL: 'bank_withdrawal',
  CASHBACK_REWARD: 'cashback_reward',
};
